import Navbars from '../Navbar';
import Result from '../Result/Result';
export default function Success(){
    return (
        <>
            <Navbars/>
            <Result />
        </>
    );
}